import { useEffect, useRef } from 'react';
import { subscribeOpportunityChanged } from '../../../utils/functions/opportunityChangeBus';

const DEFAULT_INTERVAL_MS = 10000;

// ให้หน้า Marketing เห็นข้อมูลที่ถูกแก้ล่าสุดโดยไม่ต้อง refresh — services/marketing (พอร์ต 3002) ไม่มี
// Socket.IO เหมือน backend หลัก เลยรวม 3 ทางเข้าด้วยกัน:
//  1) opportunityChangeBus (BroadcastChannel) — แก้ในเบราว์เซอร์เดียวกัน (popup/pop-out/แท็บอื่น) เห็นทันที
//  2) กลับมาที่แท็บ (focus/visible) — ดึงใหม่ทันที
//  3) interval เงียบๆ ตอนแท็บเปิดอยู่ — เห็นการแก้ของผู้ใช้/เครื่องอื่น (ช้าสุด ~intervalMs)
// callback ต้อง "เงียบ" (ไม่โชว์ spinner/ไม่ alert error) เพราะถูกเรียกเองเป็นระยะ
export function useMarketingLiveRefresh(callback, { enabled = true, intervalMs = DEFAULT_INTERVAL_MS } = {}) {
  const cbRef = useRef(callback);
  cbRef.current = callback;

  useEffect(() => {
    if (!enabled) return undefined;
    const run = () => {
      if (document.visibilityState === 'hidden') return;
      try {
        const result = cbRef.current?.();
        if (result && typeof result.catch === 'function') result.catch(() => {});
      } catch {
        // เงียบไว้ — การดึงเบื้องหลังล้มเหลวไม่ต้องรบกวนผู้ใช้
      }
    };
    const unsubscribe = subscribeOpportunityChanged(run);
    const timer = setInterval(run, intervalMs);
    window.addEventListener('focus', run);
    document.addEventListener('visibilitychange', run);
    return () => {
      unsubscribe();
      clearInterval(timer);
      window.removeEventListener('focus', run);
      document.removeEventListener('visibilitychange', run);
    };
  }, [enabled, intervalMs]);
}

export default useMarketingLiveRefresh;
